import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PropCard from '../../components/PropCard';
import SearchArea from '../../components/SearchArea';
import { getApprovedPropertyAction } from "../../redux/actions/propertyActions";
import ReactPaginate from "react-paginate";
import { FaDatabase } from 'react-icons/fa';
import { FiWifiOff } from 'react-icons/fi';

const Property = () => {
  const dispatch = useDispatch()

  const [category, setCategory] = useState("all")

  const [data, setData] = useState([])

  // --- Pagination --- //
  const [pageNumber, setPageNumber] = useState(0)
  const itemsPerPage = 15
  const pagesVisited = pageNumber * itemsPerPage
  const pageCount = Math.ceil(data?.length / itemsPerPage)
  const changePage = ({ selected }) => setPageNumber(selected)
  const displayData = data?.slice(pagesVisited, pagesVisited + itemsPerPage)
  // --- Pagination --- //

  const getApprovedProperty = useSelector(state => state.getApprovedProperty)
  const { data: properties, error } = getApprovedProperty

  useEffect(() => {
    document.title = "Island Luxury - Properties"
    dispatch(getApprovedPropertyAction())
  }, [dispatch])

  useEffect(() => {
    setData(properties?.data)
  }, [properties])

  // --- Category switching --- //
  useEffect(() => {
    if(category === "all") {
      setData(properties?.data)
    } else {
      const results = properties?.data?.filter(item => (item.category.includes(category)))
      setData(results)
    }
  }, [category])

  return (
    <div id="property">
      <Header />
      <main>
        <section className="intro-area">
          <div className="intro-area_wrap container">
            <h1>Available Property</h1>
            <SearchArea setData={setData} properties={properties} />
          </div>
        </section>
        <section className="available-property container">
          <div className="category-tab">
            <button 
              className={category === "all" ? "active" : ""}
              onClick={() => setCategory("all")}>All</button>
            <button 
              className={category === "Sale" ? "active" : ""}
              onClick={() => setCategory("Sale")}>Sale</button>
            <button 
              className={category === "Rent" ? "active" : ""}
              onClick={() => setCategory("Rent")}>Rent</button>
          </div>
            {error ? 
              <div className="error-msg">
                <FiWifiOff size={65} />
                <p>You're offline. Check your connection.</p>
              </div>
            : 
              (data?.length === 0 ? 
                <div className="error-msg">
                  <FaDatabase size={65} />
                  <p>No data found for your search!</p>
                </div>
              :
                <div className="available-property_cards">
                  {displayData?.map((item, index) => 
                    <PropCard 
                      key={index}
                      id={item._id}
                      img={item.firstImage}
                      category={item.category}
                      title={item.title}
                      price={item.price}
                      beds={item.bedrooms}
                      baths={item.bath}
                      address={item.state} />
                  )}
                </div>
              )
            }
            {data?.length > itemsPerPage &&
							<div className="pagination-tab">
								<ReactPaginate
									previousLabel={<><i className="fas fa-chevron-left" /> Previous</>}
									nextLabel={<>Next <i className="fas fa-chevron-right" /></>}
									pageCount={pageCount}
									onPageChange={changePage}
									containerClassName={"paginationBttns"}
									previousLinkClassName={"previousBttn"}
									nextLinkClassName={"nextBttn"}
									disabledClassName={"paginationDisabled"}
									activeClassName={"paginationActive"} />
							</div>
						}
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default Property;